export default "__VITE_ASSET__DVQW_WQt__"